import React from "react";
import Footer from "./components/Main/Footer";
import Navbar from "./components/Main/Navbar";
import Routes from "./Routes";

const App = () => {
  return (
    <div>
      <Navbar />
      <Routes />
      <Footer />
    </div>
  );
};

export default App;
